import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import store from "../../../../store/store";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchJourneyTeam from "../../crm/journey/searchJourneyTeam";
import SearchUser from "../users/searchUser";
import SubTasks from "./subTasks";
import { getTaskStatus } from "../../../../services/setup/user/userSetupService";
import { Cancel, Search } from "@mui/icons-material";
import {
  DialogActions,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { deleteTask, saveTask } from "../../../../services/usersService";
import { Badge, Card, Dropdown, DropdownButton } from "react-bootstrap";
import { calculateDaysBetweenDate, formatDate } from "../../../../utils/utils";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { getSalesActivities } from "../../../../services/setup/crm/crmSetupService";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function TaskContent({
  taskImp = {
    ID: 0,
    statusID: 0,
    statusName: "",
    title: "",
    description: "",
    deadlineDate: DateTime.now().endOf("day"),
    taskStatus: {
      title: "",
    },
    salesUser: false,
  },
  journeyID = 0,
  onCloseDialog,
}) {
  const [task, setTask] = useState({
    ID: 0,
    statusID: 0,
    statusName: "",
    title: "",
    deadlineDate: DateTime.now().endOf("day"),
    description: "",
    taskStatus: {
      title: "",
    },
    salesUser: false,
  });
  const [userType, setUserType] = useState(1);
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const [taskStatus, setTaskStatus] = useState([
    {
      value: 0,
      label: "",
    },
  ]);
  const [salesActivities, setSalesActivities] = useState([
    {
      value: 0,
      label: "",
    },
  ]);
  const [showSubTaskForm, setShowSubTaskForm] = useState(false);
  const [displaType, setDisplayType] = useState({
    title: "display",
    deadlineDate: "display",
    description: "display",
    userName: "display",
    status: "display",
    reviewer: "display",
  });

  const { auth } = store.getState();
  const { userID, fullName } = auth.user;
  const daysLeft = calculateDaysBetweenDate(
    DateTime.fromISO(task.deadlineDate),
    DateTime.now()
  );

  useEffect(() => {
    getTaskStatusData();
    getSalesActivitiesData();
    setTask(taskImp);
  }, [taskImp]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-8 col-md-8 col-lg-8">
          <CardField
            value={task.title}
            title="Task Card Name"
            displayType={displaType.title}
            changeDisplayType={() => {
              changeDisplayType("title");
            }}
          >
            <TextField
              value={task.title}
              variant="outlined"
              size="small"
              margin="normal"
              style={{ width: "100%" }}
              onChange={(e) => {
                const taskTmp = { ...task };
                taskTmp.title = e.target.value;
                setTask(taskTmp);
              }}
              onBlur={(e) => {
                changeDisplayType("title");
                updateTaskData("title", e.target.value);
              }}
              autoFocus={displaType.title === "edit" ? true : false}
            />
          </CardField>
          <CardField
            value={
              task.description !== ""
                ? task.description
                : "Write Description..."
            }
            title="Description"
            displayType={displaType.description}
            changeDisplayType={() => {
              changeDisplayType("description");
            }}
          >
            <TextField
              value={task.description}
              variant="outlined"
              size="small"
              margin="normal"
              style={{ width: "100%" }}
              onChange={(e) => {
                const taskTmp = { ...task };
                taskTmp.description = e.target.value;
                setTask(taskTmp);
              }}
              onBlur={(e) => {
                changeDisplayType("description");
                updateTaskData("description", e.target.value);
              }}
              autoFocus={displaType.description === "edit" ? true : false}
            />
          </CardField>
          <SubTasks
            taskID={task.ID}
            showSubTaskForm={showSubTaskForm}
            taskStatus={taskStatus}
            setShowSubTaskForm={setShowSubTaskForm}
          />
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Typography align="center">
                <button
                  type="button"
                  className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                  onClick={() => {
                    setShowSubTaskForm(true);
                  }}
                >
                  <i className="fas fa-network-wired"></i>
                  Add Sub Task
                </button>
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row justify-content-center mb-3">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="d-flex justify-content-between">
                <DropdownButton
                  title={task.statusDesc}
                  variant={task.statusID === 9999 ? "success" : "info"}
                  size="sm"
                >
                  {taskStatus.map((status, index2) => (
                    <Dropdown.Item
                      key={index2}
                      onClick={() => {
                        updateTaskData(
                          "statusID",
                          status.value,
                          "statusDesc",
                          status.label
                        );
                      }}
                    >
                      {status.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
                {(!task.archived || task.statusID < 9999) &&
                task.fromUserID === userID ? (
                  <button
                    type="button"
                    className="btn btn-label-danger btn-sm btn-pill btn-bold mx-1"
                    onClick={() => {
                      deleteTaskData();
                    }}
                  >
                    <i className="fas fa-trash-alt"></i>
                    Delete Task
                  </button>
                ) : null}
              </div>
            </div>
          </div>
          <Card>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <CardField
                    value={task.reviewer}
                    title="Reviewer"
                    displayType={displaType.reviewer}
                    changeDisplayType={() => {
                      changeDisplayType("reviewer");
                    }}
                  >
                    <TextField
                      value={task.reviewer}
                      variant="outlined"
                      size="small"
                      margin="normal"
                      style={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setUserType(2);
                                  setOpenSearchUser(true);
                                }}
                                edge="end"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                            <BootstrapTooltip title="Cancel">
                              <IconButton
                                type="button"
                                aria-label="Cancel"
                                onClick={() => {
                                  changeDisplayType("reviewer");
                                }}
                                edge="end"
                              >
                                <Cancel />
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      autoFocus={displaType.reviewer === "edit" ? true : false}
                    />
                  </CardField>
                </div>
              </div>
              <Divider className="mt-n3 mb-3" />
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <CardField
                    value={task.userName}
                    title="Assign To"
                    displayType={displaType.userName}
                    changeDisplayType={() => {
                      changeDisplayType("userName");
                    }}
                  >
                    <TextField
                      value={task.userName}
                      variant="outlined"
                      size="small"
                      margin="normal"
                      style={{ width: "100%" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setUserType(1);
                                  setOpenSearchUser(true);
                                }}
                                edge="end"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                            <BootstrapTooltip title="Cancel">
                              <IconButton
                                type="button"
                                aria-label="Cancel"
                                onClick={() => {
                                  changeDisplayType("userName");
                                }}
                                edge="end"
                              >
                                <Cancel />
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      autoFocus={displaType.userName === "edit" ? true : false}
                    />
                  </CardField>
                </div>
              </div>
              <Divider className="mt-n3 mb-3" />
              {task.salesUser ? (
                <React.Fragment>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Typography className="kt-font-bolder mb-2">
                        Sales Activity
                      </Typography>
                      <div className="card border-0 mt-2 px-3 py-2">
                        {task.visitActivityID > 0 ? (
                          <Badge variant="info">{task.salesActivityName}</Badge>
                        ) : (
                          <DropdownButton
                            title={task.salesActivityName}
                            variant="secondary"
                            size="sm"
                          >
                            {salesActivities.map((activity, index2) => (
                              <Dropdown.Item
                                key={index2}
                                onClick={() => {
                                  updateTaskData(
                                    "salesActivityID",
                                    activity.value,
                                    "salesActivityName",
                                    activity.label
                                  );
                                }}
                              >
                                {activity.label}
                              </Dropdown.Item>
                            ))}
                          </DropdownButton>
                        )}
                      </div>
                    </div>
                  </div>
                  <Divider className="mb-3" />
                </React.Fragment>
              ) : null}
              {task.operationCardID > 0 ? (
                <React.Fragment>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Typography className="kt-font-bolder mb-2">
                        Operation Card
                      </Typography>
                      <div className="card border-0 mt-2 px-3 py-2">
                        <Typography className="d-inline">
                          {task.operationCard.title}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <Divider className="mb-3" />
                </React.Fragment>
              ) : null}
              {task.statusID < 9999 ? (
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <CardField
                      value={
                        <Badge
                          variant={
                            daysLeft >= 3
                              ? "primary"
                              : daysLeft >= 0 && daysLeft < 3
                              ? "warning"
                              : daysLeft < 0
                              ? "danger"
                              : null
                          }
                        >
                          {formatDate(task.deadlineDate)}
                        </Badge>
                      }
                      title="Deadline Date"
                      displayType={displaType.deadlineDate}
                      changeDisplayType={() => {
                        changeDisplayType("deadlineDate");
                      }}
                    >
                      <KeyboardDatePicker
                        autoOk
                        size="small"
                        margin="normal"
                        style={{ width: "100%" }}
                        inputVariant="outlined"
                        variant="inline"
                        value={task.deadlineDate}
                        format="yyyy-MM-dd"
                        onClose={() => {
                          changeDisplayType("deadlineDate");
                        }}
                        onChange={(date) => {
                          updateTaskData("deadlineDate", date);
                          changeDisplayType("deadlineDate");
                        }}
                        InputProps={{
                          endAdornment: (
                            <BootstrapTooltip title="Cancel">
                              <IconButton
                                type="button"
                                aria-label="Cancel"
                                onClick={() => {
                                  changeDisplayType("deadlineDate");
                                }}
                                edge="end"
                              >
                                <Cancel />
                              </IconButton>
                            </BootstrapTooltip>
                          ),
                          readOnly: true,
                        }}
                        InputAdornmentProps={{
                          position: "start",
                        }}
                      />
                    </CardField>
                  </div>
                </div>
              ) : null}
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogLayout
        open={openSearchUser}
        title="Search User"
        onCloseDialog={handleCloseSearchUser}
        maxWIdth="lg"
      >
        {journeyID > 0 ? (
          <SearchJourneyTeam
            journeyID={journeyID}
            onSelectUser={(user) => {
              updateTaskData("userID", user.userID, "userName", user.userName);
              handleCloseSearchUser();
            }}
          />
        ) : (
          <SearchUser
            onSelectUser={(user) => {
              let userID = "";
              let userName = "";
              if (userType === 1) {
                userID = "userID";
                userName = "userName";
                changeDisplayType("userName");
              } else if (userType === 2) {
                userID = "reviewerUserID";
                userName = "reviewer";
                changeDisplayType("reviewer");
              }
              updateTaskData(
                userID,
                user.ID,
                userName,
                user.firstName + " " + user.lastName
              );

              handleCloseSearchUser();
            }}
          />
        )}
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchUser}
          >
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function changeDisplayType(name = "") {
    if (name !== "") {
      const displaTypeTmp = { ...displaType };
      if (displaTypeTmp[name] === "display") {
        displaTypeTmp[name] = "edit";
      } else {
        displaTypeTmp[name] = "display";
      }
      setDisplayType(displaTypeTmp);
    }
  }

  function updateTaskData(name = "", value, name2 = "", value2) {
    if (name !== "") {
      const taskTmp = { ...task };
      taskTmp[name] = value;
      if (name2 !== "") {
        taskTmp[name2] = value2;
      }
      saveTask(taskTmp).then((response) => {
        setTask(taskTmp);
      });
    }
  }

  function handleCloseSearchUser() {
    if (userType === 1) {
      changeDisplayType("userName");
    } else if (userType === 2) {
      changeDisplayType("reviewer");
    }
    setOpenSearchUser(false);
  }

  async function deleteTaskData() {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Task ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteTask(task.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Saved",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            onCloseDialog();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getTaskStatusData() {
    const statuses = [];
    const response = await getTaskStatus();
    const { data } = response.data;
    for (const status of data.taskStatuses) {
      statuses.push({
        value: status.ID,
        label: status.title,
      });
    }
    setTaskStatus(statuses);
  }

  async function getSalesActivitiesData() {
    const statuses = [];
    const response = await getSalesActivities();
    const { data } = response.data;
    statuses.push({
      value: 0,
      label: "Not Sales Task",
    });
    for (const status of data.salesActivities) {
      statuses.push({
        value: status.ID,
        label: status.salesActivityName,
      });
    }
    setSalesActivities(statuses);
  }
}

function CardField({
  children,
  title = "",
  value,
  displayType,
  changeDisplayType,
}) {
  return (
    <div className="row mb-3">
      <div className="col-sm-12 col-md-12 col-lg-12">
        {title !== "" ? (
          <React.Fragment>
            <Typography className="kt-font-bolder d-inline mb-2">
              {title}
            </Typography>
          </React.Fragment>
        ) : null}
        {displayType === "display" ? (
          <div className="card border-0 mt-2 px-3 py-2">
            <span>
              <span className="mr-1">
                <Typography className="d-inline">{value}</Typography>
              </span>
              <span className="mx-1">
                <BootstrapTooltip title={`Edit ${title}`}>
                  <button
                    type="button"
                    className="btn btn-icon btn-clean btn-circle btn-sm"
                    onClick={() => {
                      changeDisplayType();
                    }}
                  >
                    <i className="fas fa-pencil-alt pr-0"></i>
                  </button>
                </BootstrapTooltip>
              </span>
            </span>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}

export default TaskContent;
